import React from "react";
import SheetRecordsTable from "../../components/ui-custom/SheetRecordsTable";

// Quotations for the logged-in customer/vendor (from Google Sheet "Quotations").
const Quotations = () => <SheetRecordsTable endpoint="/portal/quotations" />;

export default Quotations;
